import vid1 from '../../assets/video/Alostro.mp4';
import thumbnail1 from '../../assets/images/thumbnails/Alostro.png';
import thumbnail2 from '../../assets/images/thumbnails/AudioCzzle.png';
import thumbnail3 from '../../assets/images/thumbnails/Big Time Schalap.png';
import thumbnail4 from '../../assets/images/thumbnails/Hamba Nobani.png';
import thumbnail5 from '../../assets/images/thumbnails/Home.png';
import thumbnail6 from '../../assets/images/thumbnails/How you Feel.png';
import thumbnail7 from '../../assets/images/thumbnails/Late Nights.png';
import thumbnail8 from '../../assets/images/thumbnails/Msholozi.png';

import vid2 from '../../assets/video/Audio Czzle.mp4';
import vid3 from '../../assets/video/Big Time Schlappa.mp4';
import vid4 from '../../assets/video/Hamba No Bani.mp4';
import vid5 from '../../assets/video/Home.mp4';
import vid6 from '../../assets/video/How You Feel.mp4';
import vid7 from '../../assets/video/Late Nights.mp4';
import vid8 from '../../assets/video/msholozi.mp4';

export const heroData = [
  {
    video: vid1,
    title: 'title1 ',
    subtitle: 'subtitle1',
    detail:
      'Detail 1 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail1,
  },
  {
    video: vid2,
    title: 'title2 ',
    subtitle: 'subtitle2',
    detail:
      'Detail 2 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail2,
  },
  {
    video: vid3,
    title: 'title3 ',
    subtitle: 'subtitle3',
    detail:
      'Detail 3 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail3,
  },
  {
    video: vid4,
    title: 'title4 ',
    subtitle: 'subtitle4',
    detail:
      'Detail 4 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail4,
  },
  {
    video: vid5,
    title: 'title5 ',
    subtitle: 'subtitle5',
    detail:
      'Detail 5 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail5,
  },
  {
    video: vid6,
    title: 'title6',
    subtitle: 'subtitle6',
    detail:
      'Detail 6 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail6,
  },
  {
    video: vid7,
    title: 'title7 ',
    subtitle: 'subtitle7',
    detail:
      'Detail 7 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail7,
  },
  {
    video: vid8,
    title: 'title8 ',
    subtitle: 'subtitle8',
    detail:
      'Detail 8 Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem qui maxime voluptates id quas eos enim cupiditate deserunt quis ea!',
    thumbnail: thumbnail8,
  },
];
